import styled from "styled-components";
import { Button, Type, List } from "discover.medical.react-component-library";

export const WrapperDiv = styled.div`
  border-collapse: collapse;
  width: 100%;
  line-height: 1.5;
`;

export const RowWithBottomBorderDiv = styled.div`
  display: table-row;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
`;

export const LabelColumnDiv = styled.div`
  display: table-cell;
  width: 33%;
  font-weight: bold;
  text-align: right;
  padding: 0.75rem;
  color: ${({ theme }) => theme.colors.gray800};
`;

export const ValueColumnDiv = styled.div`
  display: table-cell;
  width: 67%;
  padding: 0.75rem;
  color: ${({ theme }) => theme.colors.gray800};
`;

export const ReferenceAndResourcesButton = styled(Button)`
  ${({ theme }) => `font-weight: ${theme.font.weight.bold};`}
`;

export const StyledWrapper = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  width: 100%;
  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.lg};
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
    padding-bottom: ${({ theme }) => theme.space.lg};
  }
`;

export const StyledLabel = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
`;

export const StyledANCCStatementWrapper = styled(List)`
  padding: 0 ${({ theme }) => theme.space.sm};

  em {
    font-style: italic;
  }
`;
